import { html, View } from 'rune-ts';
import { classes } from '@services/MarppleShop/shared/util';
import klass from './CurationThumbnailView.module.scss';
import { font } from '@services/MarppleShop/shared/typography';
import { convertNewLinesToBr } from '@services/MarppleShop/shared/util/convertNewLinesToBr.ts';
import { pipe } from '@fxts/core';

type TProps =
  | {
      device: 'PC';
      theme: 'Light';
    }
  | {
      device: 'PC';
      theme: 'Dark';
    }
  | {
      device: 'Mobile';
      theme: 'Light';
      title: string;
      sub_title: string;
      mobile_thumbnail: string;
    }
  | {
      device: 'Mobile';
      theme: 'Dark';
      title: string;
      sub_title: string;
      mobile_thumbnail: string;
    };

/**
 * https://www.figma.com/design/IIaFJhb53ELp9PZ4XMnQWo/%ED%81%90%EB%A0%88%EC%9D%B4%EC%85%98?node-id=2270-137669&m=dev
 */
export class CurationThumbnailView extends View<TProps> {
  protected override template(props: TProps) {
    if (props.device === 'Mobile') {
      const { theme, title, sub_title, mobile_thumbnail } = props;

      return html`<div class="${klass.curation_thumbnail}">
        <img alt="" src="${mobile_thumbnail}" class="${klass.image}" />

        <div class="${classes(klass.title_container, { [klass.theme_dark]: theme === 'Dark' })}">
          <div class="${klass.text}">
            <p
              class="${classes(
                klass.title_text,
                { [klass.theme_dark]: theme === 'Dark' },
                font('24_semibold'),
              )}"
            >
              ${pipe(title, convertNewLinesToBr, html.preventEscape)}
            </p>

            <p
              class="${classes(
                klass.sub_title_text,
                { [klass.theme_light]: theme === 'Light', [klass.theme_dark]: theme === 'Dark' },
                font('14_regular'),
              )}"
            >
              ${pipe(sub_title, convertNewLinesToBr, html.preventEscape)}
            </p>
          </div>
        </div>
      </div>`;
    } else {
      throw new Error();
    }
  }
}
